import React, { useState, useEffect } from 'react';
import SideMenu from "../../component/SideMenu";
import Topbar from "../../component/Topbar";
import { Link } from 'react-router-dom';
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';

const Projects = () => {
  const [activeTab, setActiveTab] = useState('All Assets');
  const [projectData, setProjectData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Data from API
  const fetchProjects = async () => {
    const userToken = localStorage.getItem('userToken');
    try {
      const response = await axios.get(`${baseurl}getUserProjects`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      if (response.data.success) {
        setProjectData(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching projects:", err);
      Swal.fire('Error', 'Failed to load projects', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  // Filter logic based on tabs
  const filteredData = projectData.filter(item => {
    if (activeTab === 'All Assets') return true;
    if (activeTab === 'Drafts') return item.status === 'Draft';
    if (activeTab === 'Processing') return item.status === 'Pending';
    return true;
  });

  return (
    <div className="app-container">
      <Topbar />
      <div className="main-wrapper" style={{ background: '#F4F7FE', display: 'flex' }}>
        <SideMenu />

        <div className="profile-content-container p-2" style={{ flex: 1, overflow: 'auto' }}>
          
          {/* HEADER BAR */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="m-0 fw-800" style={{ color: '#1B2559', fontSize: '28px' }}>Project Inventory</h2>
              <p className="m-0" style={{ color: '#A3AED0', fontSize: '15px' }}>
                Manage and track all property measurements across your portfolio.
              </p>
            </div>
            <Link to="/map" className="btn-create-project" style={{ textDecoration: 'none' }}>
              <i className="fa-solid fa-plus me-2"></i> Create New Project
            </Link>
          </div>

          {/* FILTER TABS */}
          <div className="d-flex align-items-center gap-2 mb-4 flex-wrap">
            {['All Assets', 'Drafts', 'Processing'].map((tab) => (
              <button 
                key={tab}
                className={`btn-tab ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* SEARCH AND SORT BAR */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-3 align-items-center" style={{ flex: 1 }}>
              <div className="search-input-wrapper">
                <i className="fa-solid fa-filter search-icon"></i>
                <input type="text" className="inventory-search" placeholder="Filter inventory..." />
              </div>
            </div>
            <div style={{ color: '#A3AED0', fontSize: '14px', fontWeight: '600' }}>
              Showing {filteredData.length} projects
            </div>
          </div>

          {/* PROJECTS TABLE */}
          <div className="premium-card p-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table inventory-table m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>PROPERTY IDENTITY</th>
                    <th>SITE ADDRESS</th>
                    <th>AREA (SQFT)</th>
                    <th>REPORT</th>
                    <th>CURRENT STATUS</th>
                    <th>TIMELINE</th>
                    <th className="text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="8" className="text-center p-5">Loading Projects...</td></tr>
                  ) : filteredData.length === 0 ? (
                    <tr><td colSpan="8" className="text-center p-5">No projects found.</td></tr>
                  ) : (
                    filteredData.map((item, index) => (
                      <tr key={item.id}>
                        <td style={{ color: '#A3AED0' }}>{index + 1}</td>
                        <td className="fw-bold" style={{ color: '#1a237e' }}>{item.property_id}</td>
                        <td style={{ color: '#1B2559', maxWidth: '250px' }}>
                          <i className="fa-solid fa-location-dot me-2" style={{color: '#A3AED0'}}></i>
                          {item.project_data.address || "No Address Provided"}
                        </td>
                        <td style={{ color: '#1B2559' }}>{item.project_data.lotArea}</td>
                        <td className="fw-bold" style={{ color: '#1B2559' }}>{item.project_data.reportType}</td>
                        <td>
                          <span className={`status-badge ${item.status.toLowerCase()}`}>
                            <span className="status-dot"></span> {item.status}
                          </span>
                        </td>
                        <td style={{ color: '#A3AED0' }}>
                          {new Date(item.created_at).toLocaleDateString('en-US', {
                            month: 'short', day: '2-digit', year: 'numeric'
                          })}
                        </td>
                        <td className="text-center">
                          <Link to={`/report/${item.property_id}`} className="btn-table-action">
                            <i className="fa-solid fa-arrow-right-to-bracket"></i>
                          </Link>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;